// services/subscriberService.ts
import { HttpClient } from "@/app/api/HttpClient"
import { StrapiListResponse } from "@/types/types"
import { buildUrlWithQuery } from "@/utils/query-string-api-helper"

export interface SubscriberAttributes {
  email: string
  name?: string
  publishedAt?: string
}

export interface GetSubscribersParams {
  pagination?: {
    page?: number
    pageSize?: number
  }
  filters?: Record<string, any>
  sort?: string
  publicationState?: "live" | "preview"
}

export const getSubscribers = async (
  params: GetSubscribersParams = {},
): Promise<StrapiListResponse<SubscriberAttributes>> => {
  const query = {
    populate: "*",
    ...params,
  }

  const res = await HttpClient.get<StrapiListResponse<SubscriberAttributes>>(
    buildUrlWithQuery("/api/subscribers", query),
  )

  if (!res) {
    throw new Error("Failed to fetch subscribers")
  }

  return res
}
